import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import compose from "lodash/flowRight";
import {graphql} from "react-apollo";
import {connect} from "react-redux";
import get from "lodash/get";
import find from "lodash/find";
import {productSpec} from "shared/AnalyticsNew/constants/productSpecification";
import {withTranslation} from "@unibuddy/intl";
import withAuth from "shared/Auth/withAuth/withAuth";
import {replaceMe} from "shared/Auth/actions/authActions";
import RecordAnalytics from "shared/Analytics/RecordAnalytics";
import updateApplicantUniversityMutation from "../../mutations/updateApplicantUniversityMutation";
import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_NOT_YET, INTL_YES} from "../../../../../translations/chat";

export function withAskHasAppliedComponent(WrappedComponent) {
    class Parent extends Component {
        async onClick(applied) {
            // send mixpanel event
            RecordAnalytics.event(this.props, "Answered Has Applied University", {
                response: applied ? "yes" : "no",
                product: this.props.location.pathname.includes(`/pwa/${this.props.universitySlug}`)
                    ? productSpec.pwaUniversityWidget.NAME
                    : productSpec.embeddedUniversityWidget.NAME,
            });

            const universitySlug = this.props.match.params.universitySlug;
            // optimistically set to complete
            this.props.dispatch(
                replaceMe({
                    ...this.props.me,
                    applicant: {
                        ...this.props.me.applicant,
                        applicantUniversities: get(
                            this.props,
                            "me.applicant.applicantUniversities",
                            [],
                        ).map((uniLink) => {
                            if (uniLink.university.slug !== universitySlug) return uniLink;

                            return {
                                ...uniLink,
                                university: {
                                    ...uniLink.university,
                                },
                                applied,
                            };
                        }),
                    },
                }),
            );
            const result = await this.props.updateApplicantUniversity({
                variables: {
                    universitySlug,
                    applied,
                },
            });
            this.props.dispatch(replaceMe(result.data.updateMyUniversityLink.me));
        }

        /**
         * Find the me.applicant.applicantUniversities in the redux store for the current
         * and see if it has been applied to
         * @returns {boolean} true if the university has been applied to
         */
        hasCurrentUniversityApplied = () => {
            const universitySlug = this.props.match.params.universitySlug;
            const universityLinks = get(this.props, "me.applicant.applicantUniversities", []);
            const linkWithCurrentUni = find(universityLinks, {university: {slug: universitySlug}});

            if (linkWithCurrentUni) {
                return linkWithCurrentUni.applied !== null;
            }

            return false;
        };

        render() {
            return (
                <WrappedComponent
                    askHasApplied={{
                        onClick: this.onClick.bind(this),
                        complete: this.hasCurrentUniversityApplied(),
                        question: `${this.props.t(
                            "hasAppliedQuestion",
                            "Have you already applied to",
                        )} ${get(this.props, "university.name", "")}?`,
                        options: [
                            {
                                text: this.props.t(INTL_NOT_YET.key, INTL_NOT_YET.defaultValue),
                                onClick: () => this.onClick(false),
                            },
                            {
                                text: this.props.t(INTL_YES.key, INTL_YES.defaultValue),
                                onClick: () => this.onClick(true),
                            },
                        ],
                    }}
                    {...this.props}
                />
            );
        }
    }

    return Parent;
}

function enhancedWithAskHasApplied(WrappedComponent) {
    return compose(
        connect(),
        withRouter,
        withAuth,
        withTranslation(IntlNamespaces.CHAT),
        graphql(updateApplicantUniversityMutation, {name: "updateApplicantUniversity"}),
    )(withAskHasAppliedComponent(WrappedComponent));
}

export default enhancedWithAskHasApplied;
